/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx, keyframes } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { type IconMessageWrapperProps } from './types';

const breatheAnimation = keyframes({
	'0%': {
		opacity: 1,
	},
	'50%': {
		opacity: 0.3,
	},
	'100%': {
		opacity: 1,
	},
});

const animatedStyles = css({
	animationName: breatheAnimation,
	animationDuration: '3.5s',
	animationTimingFunction: 'ease-in-out',
	animationIterationCount: 'infinite',
});

const baseStyles = css({
	overflow: 'hidden',
	opacity: 1,
	fontWeight: token('font.weight.medium'),
	color: token('color.text.subtlest'),
	textAlign: 'center',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginBottom: '-1em', // Needs pixel precision to align the icon at the center of the box
	paddingBlock: token('space.050'),
	paddingInline: token('space.100'),
});

export const IconMessageWrapper = (props: IconMessageWrapperProps): JSX.Element => {
	const { animated } = props;

	return (
		<div
			id="iconMessageWrapper"
			data-testid="icon-message-wrapper"
			css={[baseStyles, animated && animatedStyles]}
		>
			{props.children}
		</div>
	);
};
